export const QUIZ = 'QUIZ';
export const QUIZ_QUESTIONS = 'QUIZ_QUESTIONS';
export const NO_ANSWER_QUESTION = 'NO_ANSWER_QUESTION';



// WEBPACK FOOTER //
// ./src/store/modules/quiz/mutation-types.js